const OPEN_MODAL = 'scratch-gui/modals/OPEN_MODAL';
const CLOSE_MODAL = 'scratch-gui/modals/CLOSE_MODAL';
const UPDATE_MODAL = 'UPDATE_MODAL';

const MODAL_BACKDROP_LIBRARY = 'backdropLibrary';
const MODAL_CAMERA_CAPTURE = 'cameraCapture';
const MODAL_COSTUME_LIBRARY = 'costumeLibrary';
const MODAL_EXTENSION_LIBRARY = 'extensionLibrary';
const MODAL_LOADING_PROJECT = 'loadingProject';
const MODAL_TELEMETRY = 'telemetryModal';
const MODAL_SOUND_LIBRARY = 'soundLibrary';
const MODAL_SPRITE_LIBRARY = 'spriteLibrary';
const MODAL_SOUND_RECORDER = 'soundRecorder';
const MODAL_CONNECTION = 'connectionModal';
const MODAL_TIPS_LIBRARY = 'tipsLibrary';
// zswl start
const MODAL_CASE_RESOURCE = 'caseResourceLibrary';
const MODAL_BRAIN_SCIENCE = 'brainScience';
const MODAL_BRAIN_SCIENCE_DATA = 'brainScienceData';
const CHART_DATA_MODAL = 'chartDataModal';

// const MODAL_BRAIN_SCIENCE_DATA = "brainScienceData"
const HANDPY_SIM_MODAL = 'handpySimModal'; // 掌控板
const OPEN_HANDPY_BOARD = 'OPEN_HANDPY_BOARD';
const CLOSE_HANDPY_BOARD = 'CLOSE_HANDPY_BOARD';
const UPDATE_HANDPY_BOARD_SCREEN = 'HANDPY_BOARD_SCREEN'; // 掌控板led屏
const HANDPY_BOARD_SCREEN_1 = 'HANDPY_BOARD_SCREEN_1';
const HANDPY_BOARD_SCREEN_2 = 'HANDPY_BOARD_SCREEN_2';
const HANDPY_BOARD_SCREEN_3 = 'HANDPY_BOARD_SCREEN_3';
const HANDPY_BOARD_SCREEN_4 = 'HANDPY_BOARD_SCREEN_4';
const HANDPY_BOARD_SCREEN_1_T = 'HANDPY_BOARD_SCREEN_1_T';
const HANDPY_BOARD_SCREEN_2_T = 'HANDPY_BOARD_SCREEN_2_T';
const HANDPY_BOARD_SCREEN_3_T = 'HANDPY_BOARD_SCREEN_3_T';
const HANDPY_BOARD_SCREEN_4_T = 'HANDPY_BOARD_SCREEN_4_T';
const HANDPY_BOARD_SCREEN_SHOW = 'HANDPY_BOARD_SCREEN_SHOW';
const UPDATE_HANDPY_BOARD_BUTTON = 'UPDATE_HANDPY_BOARD_BUTTON'; // 掌控板按钮触摸板
const HANDPY_BOARD_BUTTON_DATA = 'HANDPY_BOARD_BUTTON_DATA';

const HANDPY_WEBSITE_MODAL = 'HANDPY_WEBSITE_MODAL'; // 数据列表网页
const OPEN_HANDPY_WEBSITE_MODAL = 'OPEN_HANDPY_WEBSITE_MODAL';
const CLOSE_HANDPY_WEBSITE_MODAL = 'CLOSE_HANDPY_WEBSITE_MODAL';

const HANDPY_SIOT_TOPIC1 = 'HANDPY_SIOT_TOPIC1'; // 掌控板 SIoT 模块
const HANDPY_SIOT_TOPIC2 = 'HANDPY_SIOT_TOPIC2';
const HANDPY_SIOT_TOPIC3 = 'HANDPY_SIOT_TOPIC3';
const HANDPY_SIOT_TOPIC1_DATA = 'HANDPY_SIOT_TOPIC1_DATA';
const HANDPY_SIOT_TOPIC2_DATA = 'HANDPY_SIOT_TOPIC2_DATA';
const HANDPY_SIOT_TOPIC3_DATA = 'HANDPY_SIOT_TOPIC3_DATA';
const UPDATE_HANDPY_SIOT_TOPIC = 'UPDATE_HANDPY_SIOT_TOPIC';
const UPDATE_HANDPY_SIOT_TOPIC_DATA = 'UPDATE_HANDPY_SIOT_TOPIC_DATA';

const HANDPY_MOBILE_BTN_MODAL = 'HANDPY_MOBILE_BTN_MODAL'; // 远程指令手机界面
const OPEN_HANDPY_MOBILE_BTN_MODAL = 'OPEN_HANDPY_MOBILE_BTN_MODAL';
const CLOSE_HANDPY_MOBILE_BTN_MODAL = 'CLOSE_HANDPY_MOBILE_BTN_MODAL';
const HANDPY_MOBILE_MSG_MODAL = 'HANDPY_MOBILE_MSG_MODAL'; // 数据列表手机界面
const OPEN_HANDPY_MOBILE_MSG_MODAL = 'OPEN_HANDPY_MOBILE_MSG_MODAL';
const CLOSE_HANDPY_MOBILE_MSG_MODAL = 'CLOSE_HANDPY_MOBILE_MSG_MODAL';
const HANDPY_MOBILE_BTN_MODAL_SWITCH = 'HANDPY_MOBILE_BTN_MODAL_SWITCH'; // 远程指令手机蓝牙开关
const HANDPY_MOBILE_MSG_MODAL_SWITCH = 'HANDPY_MOBILE_MSG_MODAL_SWITCH'; // 数据列表手机蓝牙开关
const UPDATE_HANDPY_MOBILE_BTN_MODAL_SWITCH = 'UPDATE_HANDPY_MOBILE_BTN_MODAL_SWITCH';
const UPDATE_HANDPY_MOBILE_MSG_MODAL_SWITCH = 'UPDATE_HANDPY_MOBILE_MSG_MODAL_SWITCH';
const HANDPY_MOBILE_MODAL_BLE_NAME = 'HANDPY_MOBILE_MODAL_BLE_NAME'; // 蓝牙设备名
const UPDATE_HANDPY_MOBILE_MODAL_BLE_NAME = 'UPDATE_HANDPY_MOBILE_MODAL_BLE_NAME';
const HANDPY_MOBILE_BTN_MODAL_BLE = 'HANDPY_MOBILE_BTN_MODAL_BLE'; // 蓝牙设备连接状态
const HANDPY_MOBILE_MSG_MODAL_BLE = 'HANDPY_MOBILE_MSG_MODAL_BLE';
const UPDATE_HANDPY_MOBILE_BTN_MODAL_BLE = 'UPDATE_HANDPY_MOBILE_BTN_MODAL_BLE';
const UPDATE_HANDPY_MOBILE_MSG_MODAL_BLE = 'UPDATE_HANDPY_MOBILE_MSG_MODAL_BLE';
const HANDPY_MOBILE_MSG = 'HANDPY_MOBILE_MSG'; // 手机通过蓝牙发送指令
const UPDATE_HANDPY_MOBILE_MSG = 'UPDATE_HANDPY_MOBILE_MSG';
const HANDPY_MOBILE_MODAL_BLE_MSG = 'HANDPY_MOBILE_MODAL_BLE_MSG'; // 手机通过蓝牙接收数据
const UPDATE_HANDPY_MOBILE_MODAL_BLE_MSG = 'UPDATE_HANDPY_MOBILE_MODAL_BLE_MSG';

// zswl end

const initialState = {
    [MODAL_BACKDROP_LIBRARY]: false,
    [MODAL_CAMERA_CAPTURE]: false,
    [MODAL_COSTUME_LIBRARY]: false,
    [MODAL_EXTENSION_LIBRARY]: false,
    [MODAL_LOADING_PROJECT]: false,
    [MODAL_TELEMETRY]: false,
    [MODAL_SOUND_LIBRARY]: false,
    [MODAL_SPRITE_LIBRARY]: false,
    [MODAL_SOUND_RECORDER]: false,
    [MODAL_CONNECTION]: false,
    [MODAL_TIPS_LIBRARY]: false,
    [MODAL_CASE_RESOURCE]: false,
    [MODAL_BRAIN_SCIENCE]: false,
    [CHART_DATA_MODAL]: false,
    [MODAL_BRAIN_SCIENCE_DATA]: [],

    [HANDPY_SIM_MODAL]: false,
    [HANDPY_BOARD_SCREEN_SHOW]: false,
    [HANDPY_BOARD_SCREEN_1]: '',
    [HANDPY_BOARD_SCREEN_2]: '',
    [HANDPY_BOARD_SCREEN_3]: '',
    [HANDPY_BOARD_SCREEN_4]: '',
    [HANDPY_BOARD_SCREEN_1_T]: '',
    [HANDPY_BOARD_SCREEN_2_T]: '',
    [HANDPY_BOARD_SCREEN_3_T]: '',
    [HANDPY_BOARD_SCREEN_4_T]: '',
    [HANDPY_BOARD_BUTTON_DATA]: {
        timestamp: 0,
        data: {
            A: 'up',
            B: 'up',
            P: 'up',
            Y: 'up',
            T: 'up',
            H: 'up',
            O: 'up',
            N: 'up'
        }
    },

    [HANDPY_WEBSITE_MODAL]: false,

    [HANDPY_SIOT_TOPIC1]: '',
    [HANDPY_SIOT_TOPIC2]: '',
    [HANDPY_SIOT_TOPIC3]: '',
    [HANDPY_SIOT_TOPIC1_DATA]: [],
    [HANDPY_SIOT_TOPIC2_DATA]: [],
    [HANDPY_SIOT_TOPIC3_DATA]: [],

    [HANDPY_MOBILE_BTN_MODAL]: false,
    [HANDPY_MOBILE_MSG_MODAL]: false,
    [HANDPY_MOBILE_BTN_MODAL_SWITCH]: false,
    [HANDPY_MOBILE_MSG_MODAL_SWITCH]: false,
    [HANDPY_MOBILE_MODAL_BLE_NAME]: '',
    [HANDPY_MOBILE_BTN_MODAL_BLE]: false,
    [HANDPY_MOBILE_MSG_MODAL_BLE]: false,
    [HANDPY_MOBILE_MSG]: {
        timestamp: 0,
        data: ''
    },
    [HANDPY_MOBILE_MODAL_BLE_MSG]: []
};

const siot_topic_map = {
    topic_1: HANDPY_SIOT_TOPIC1,
    topic_2: HANDPY_SIOT_TOPIC2,
    topic_3: HANDPY_SIOT_TOPIC3,
}
const siot_topic_data_map = {
    topic_1: HANDPY_SIOT_TOPIC1_DATA,
    topic_2: HANDPY_SIOT_TOPIC2_DATA,
    topic_3: HANDPY_SIOT_TOPIC3_DATA,
}

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true,
            [MODAL_BRAIN_SCIENCE_DATA]: action.data || []
        });
    case CLOSE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    case UPDATE_MODAL:
        return Object.assign({}, state, {
            [MODAL_BRAIN_SCIENCE_DATA]: action.data || []
        });
    case OPEN_HANDPY_BOARD:
        return Object.assign({}, state, {
            [action.modal]: true,
            [`${UPDATE_HANDPY_BOARD_SCREEN}_1`]: '',
            [`${UPDATE_HANDPY_BOARD_SCREEN}_2`]: '',
            [`${UPDATE_HANDPY_BOARD_SCREEN}_3`]: '',
            [`${UPDATE_HANDPY_BOARD_SCREEN}_4`]: ''
        });
    case CLOSE_HANDPY_BOARD:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    case UPDATE_HANDPY_BOARD_SCREEN:
        return Object.assign({}, state, {
            [`${UPDATE_HANDPY_BOARD_SCREEN}_${action.line}_T`]: action.data
        });
    case HANDPY_BOARD_SCREEN_SHOW:
        let str_1 = state[HANDPY_BOARD_SCREEN_1_T]
        let str_2 = state[HANDPY_BOARD_SCREEN_2_T]
        let str_3 = state[HANDPY_BOARD_SCREEN_3_T]
        let str_4 = state[HANDPY_BOARD_SCREEN_4_T]
        return Object.assign({}, state, {
            [HANDPY_BOARD_SCREEN_1]: str_1,
            [HANDPY_BOARD_SCREEN_2]: str_2,
            [HANDPY_BOARD_SCREEN_3]: str_3,
            [HANDPY_BOARD_SCREEN_4]: str_4
        });

    case UPDATE_HANDPY_BOARD_BUTTON:
        return Object.assign({}, state, {
            [HANDPY_BOARD_BUTTON_DATA]: {
                timestamp: action.data.timestamp,
                data: {
                    ...state[HANDPY_BOARD_BUTTON_DATA].data,
                    ...action.data.data
                }
            }
        });

    case OPEN_HANDPY_WEBSITE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true,
            [HANDPY_SIOT_TOPIC1]: '',
            [HANDPY_SIOT_TOPIC2]: '',
            [HANDPY_SIOT_TOPIC3]: '',
            [HANDPY_SIOT_TOPIC1_DATA]: [],
            [HANDPY_SIOT_TOPIC2_DATA]: [],
            [HANDPY_SIOT_TOPIC3_DATA]: []
        });
    case CLOSE_HANDPY_WEBSITE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    case OPEN_HANDPY_MOBILE_BTN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true,
            [HANDPY_MOBILE_BTN_MODAL_SWITCH]: false,
            [HANDPY_MOBILE_BTN_MODAL_BLE]: false,
        });
    case CLOSE_HANDPY_MOBILE_BTN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    case OPEN_HANDPY_MOBILE_MSG_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true,
            [HANDPY_MOBILE_MSG_MODAL_SWITCH]: false,
            [HANDPY_MOBILE_MSG_MODAL_BLE]: false,
            [HANDPY_MOBILE_MODAL_BLE_MSG]: []
        });
    case CLOSE_HANDPY_MOBILE_MSG_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    
    
    case UPDATE_HANDPY_MOBILE_BTN_MODAL_SWITCH:
        return Object.assign({}, state, {
            [HANDPY_MOBILE_BTN_MODAL_SWITCH]: action.data
        });
    case UPDATE_HANDPY_MOBILE_MSG_MODAL_SWITCH:
        return Object.assign({}, state, {
            [HANDPY_MOBILE_MSG_MODAL_SWITCH]: action.data
        });

    case UPDATE_HANDPY_MOBILE_MODAL_BLE_NAME:
        return Object.assign({}, state, {
            [HANDPY_MOBILE_MODAL_BLE_NAME]: action.data
        });
    case UPDATE_HANDPY_MOBILE_BTN_MODAL_BLE:
        return Object.assign({}, state, {
            [HANDPY_MOBILE_BTN_MODAL_BLE]: action.data
        });
    case UPDATE_HANDPY_MOBILE_MSG_MODAL_BLE:
        return Object.assign({}, state, {
            [HANDPY_MOBILE_MSG_MODAL_BLE]: action.data
        });
    case UPDATE_HANDPY_MOBILE_MSG:
        return Object.assign({}, state, {
            [HANDPY_MOBILE_MSG]: {
                timestamp: new Date().getTime(),
                data: action.data
            }
        });
    case UPDATE_HANDPY_MOBILE_MODAL_BLE_MSG:
        if (state[HANDPY_MOBILE_MSG_MODAL_SWITCH]) {
            let tempArr_1 = []
            state[HANDPY_MOBILE_MODAL_BLE_MSG].map(i => {
                tempArr_1.push(i)
            })
            tempArr_1.push({
                timestamp: new Date(),
                message: action.message
            })
            if (tempArr_1.length > 50) {
                tempArr_1 = tempArr_1.splice((tempArr_1.length - 50), tempArr_1.length)
            }
            return Object.assign({}, state, {
                [HANDPY_MOBILE_MODAL_BLE_MSG]: tempArr_1
            });
        } else {
            return state
        }
        

    case UPDATE_HANDPY_SIOT_TOPIC:
        return Object.assign({}, state, {
            [siot_topic_map[action.topic]]: action.topicname
        });
    case UPDATE_HANDPY_SIOT_TOPIC_DATA:
        let tempArr_2 = []
        state[siot_topic_data_map[action.topic]].map(i => {
            tempArr_2.push(i)
        })
        tempArr_2.push({
            timestamp: new Date(),
            message: action.message
        })
        if (tempArr_2.length > 50) {
            tempArr_2 = tempArr_2.splice((tempArr_2.length - 50), tempArr_2.length)
        }
        return Object.assign({}, state, {
            [siot_topic_data_map[action.topic]]: tempArr_2
        });
    default:
        return state;
    }
};
const openModal = function (modal) {
    return {
        type: OPEN_MODAL,
        modal: modal
    };
};
const closeModal = function (modal) {
    return {
        type: CLOSE_MODAL,
        modal: modal
    };
};
const openBackdropLibrary = function () {
    return openModal(MODAL_BACKDROP_LIBRARY);
};
const openCameraCapture = function () {
    return openModal(MODAL_CAMERA_CAPTURE);
};
const openCostumeLibrary = function () {
    return openModal(MODAL_COSTUME_LIBRARY);
};
const openExtensionLibrary = function () {
    return openModal(MODAL_EXTENSION_LIBRARY);
};
const openLoadingProject = function () {
    return openModal(MODAL_LOADING_PROJECT);
};
const openTelemetryModal = function () {
    return openModal(MODAL_TELEMETRY);
};
const openSoundLibrary = function () {
    return openModal(MODAL_SOUND_LIBRARY);
};
const openSpriteLibrary = function () {
    return openModal(MODAL_SPRITE_LIBRARY);
};
const openSoundRecorder = function () {
    return openModal(MODAL_SOUND_RECORDER);
};
const openConnectionModal = function () {
    return openModal(MODAL_CONNECTION);
};
const openTipsLibrary = function () {
    return openModal(MODAL_TIPS_LIBRARY);
};
// zswl begin
const openCaseResource = function () {
    return openModal(MODAL_CASE_RESOURCE);
};
const closeCaseResource = function () {
    return closeModal(MODAL_CASE_RESOURCE);
};
const openBrainScience = function (data) {
    return {
        type: OPEN_MODAL,
        modal: MODAL_BRAIN_SCIENCE,
        data
    };
};
const updateBrainScience = function (data) {
    return {
        type: UPDATE_MODAL,
        data
    };
};
const closeBrainScience = function () {
    return closeModal(MODAL_BRAIN_SCIENCE);
};
const openChartDataModal = function () {
    return openModal(CHART_DATA_MODAL);
};
const closeChartDataModal = function () {
    return closeModal(CHART_DATA_MODAL);
};



const openHandpySimModal = function () {
    // return openModal(HANDPY_SIM_MODAL);
    return {
        type: OPEN_HANDPY_BOARD,
        modal: HANDPY_SIM_MODAL
    };
};
const closeHandpySimModal = function () {
    // return closeModal(HANDPY_SIM_MODAL);
    return {
        type: CLOSE_HANDPY_BOARD,
        modal: HANDPY_SIM_MODAL
    };
};
const updateHandpyScreenData = function (data) {
    return {
        type: UPDATE_HANDPY_BOARD_SCREEN,
        line: data.line || 1,
        data: data.data || ''
    };
};
const updateHandpyScreenLine1 = function (data) {
    return updateHandpyScreenData({
        line: 1,
        data
    });
};
const updateHandpyScreenLine2 = function (data) {
    return updateHandpyScreenData({
        line: 2,
        data
    });
};
const updateHandpyScreenLine3 = function (data) {
    return updateHandpyScreenData({
        line: 3,
        data
    });
};
const updateHandpyScreenLine4 = function (data) {
    return updateHandpyScreenData({
        line: 4,
        data
    });
};
const handpyBoardButtonAction = function (data) {
    return {
        type: UPDATE_HANDPY_BOARD_BUTTON,
        data
    };
}
const updateHandpyScreenShow = function (data) {
    return {
        type: HANDPY_BOARD_SCREEN_SHOW,
        data
    };
};

const openHandpyWebsiteModal = function () {
    return {
        type: OPEN_HANDPY_WEBSITE_MODAL,
        modal: HANDPY_WEBSITE_MODAL
    };
};
const closeHandpyWebsiteModal = function () {
    return {
        type: CLOSE_HANDPY_WEBSITE_MODAL,
        modal: HANDPY_WEBSITE_MODAL
    };
};
const openHandpyMobileBtnModal = function () {
    return {
        type: OPEN_HANDPY_MOBILE_BTN_MODAL,
        modal: HANDPY_MOBILE_BTN_MODAL
    };
};
const closeHandpyMobileBtnModal = function () {
    return {
        type: CLOSE_HANDPY_MOBILE_BTN_MODAL,
        modal: HANDPY_MOBILE_BTN_MODAL
    };
};
const openHandpyMobileMsgModal = function () {
    return {
        type: OPEN_HANDPY_MOBILE_MSG_MODAL,
        modal: HANDPY_MOBILE_MSG_MODAL
    };
};
const closeHandpyMobileMsgModal = function () {
    return {
        type: CLOSE_HANDPY_MOBILE_MSG_MODAL,
        modal: HANDPY_MOBILE_MSG_MODAL
    };
};
const updateHandpyMobileBtnModalSwitch = function (data) {
    return {
        type: UPDATE_HANDPY_MOBILE_BTN_MODAL_SWITCH,
        data
    };
};
const updateHandpyMobileMsgModalSwitch = function (data) {
    return {
        type: UPDATE_HANDPY_MOBILE_MSG_MODAL_SWITCH,
        data
    };
};
const updateHandpyMobileModalBleName = function (data) {
    return {
        type: UPDATE_HANDPY_MOBILE_MODAL_BLE_NAME,
        data
    };
};
const updateHandpyMobileBtnModalBle = function (data) {
    return {
        type: UPDATE_HANDPY_MOBILE_BTN_MODAL_BLE,
        data
    };
};
const updateHandpyMobileMsgModalBle = function (data) {
    return {
        type: UPDATE_HANDPY_MOBILE_MSG_MODAL_BLE,
        data
    };
};
const updateHandpyMobileMsg = function (data) {
    return {
        type: UPDATE_HANDPY_MOBILE_MSG,
        data
    };
};
const updateHandpyMobileModalBleMsg = function (data) {
    return {
        type: UPDATE_HANDPY_MOBILE_MODAL_BLE_MSG,
        message: data
    };
};

const updateHandpySiotTopic = function (data) {
    return {
        type: UPDATE_HANDPY_SIOT_TOPIC,
        topic: data.topic,
        topicname: data.topicname
    };
};
const updateHandpySiotTopicData = function (data) {
    return {
        type: UPDATE_HANDPY_SIOT_TOPIC_DATA,
        topic: data.topic,
        message: data.message
    };
};

// zswl end
const closeBackdropLibrary = function () {
    return closeModal(MODAL_BACKDROP_LIBRARY);
};
const closeCameraCapture = function () {
    return closeModal(MODAL_CAMERA_CAPTURE);
};
const closeCostumeLibrary = function () {
    return closeModal(MODAL_COSTUME_LIBRARY);
};
const closeExtensionLibrary = function () {
    return closeModal(MODAL_EXTENSION_LIBRARY);
};
const closeLoadingProject = function () {
    return closeModal(MODAL_LOADING_PROJECT);
};
const closeTelemetryModal = function () {
    return closeModal(MODAL_TELEMETRY);
};
const closeSpriteLibrary = function () {
    return closeModal(MODAL_SPRITE_LIBRARY);
};
const closeSoundLibrary = function () {
    return closeModal(MODAL_SOUND_LIBRARY);
};
const closeSoundRecorder = function () {
    return closeModal(MODAL_SOUND_RECORDER);
};
const closeTipsLibrary = function () {
    return closeModal(MODAL_TIPS_LIBRARY);
};
const closeConnectionModal = function () {
    return closeModal(MODAL_CONNECTION);
};

export {
    reducer as default,
    initialState as modalsInitialState,
    openBackdropLibrary,
    openCameraCapture,
    openCostumeLibrary,
    openExtensionLibrary,
    openLoadingProject,
    openSoundLibrary,
    openSpriteLibrary,
    openSoundRecorder,
    openTelemetryModal,
    openTipsLibrary,
    openConnectionModal,
    closeBackdropLibrary,
    closeCameraCapture,
    closeCostumeLibrary,
    closeExtensionLibrary,
    closeLoadingProject,
    closeSpriteLibrary,
    closeSoundLibrary,
    closeSoundRecorder,
    closeTelemetryModal,
    closeTipsLibrary,
    closeConnectionModal,
    openCaseResource,
    closeCaseResource,
    openBrainScience,
    closeBrainScience,
    updateBrainScience,
    openChartDataModal,
    closeChartDataModal,

    openHandpySimModal,
    closeHandpySimModal,
    updateHandpyScreenData,
    updateHandpyScreenLine1,
    updateHandpyScreenLine2,
    updateHandpyScreenLine3,
    updateHandpyScreenLine4,
    handpyBoardButtonAction,
    updateHandpyScreenShow,


    openHandpyWebsiteModal,
    closeHandpyWebsiteModal,
    openHandpyMobileBtnModal,
    closeHandpyMobileBtnModal,
    openHandpyMobileMsgModal,
    closeHandpyMobileMsgModal,
    updateHandpyMobileBtnModalSwitch,
    updateHandpyMobileMsgModalSwitch,
    updateHandpyMobileModalBleName,
    updateHandpyMobileBtnModalBle,
    updateHandpyMobileMsgModalBle,
    updateHandpyMobileMsg,
    updateHandpyMobileModalBleMsg,

    updateHandpySiotTopic,
    updateHandpySiotTopicData
};
